import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m13.204 15.48-.381.178v6.082l1.593-.796a.62.62 0 0 1 .837.279.624.624 0 0 1-.279.837l-2.496 1.248a.6.6 0 0 1-.316.065.625.625 0 0 1-.587-.623v-7.102l-7.882-3.911a1.248 1.248 0 0 1 .362-2.351l21.341-3.348a3.12 3.12 0 0 1 3.283 4.46l-6.562 14.71a1.248 1.248 0 0 1-2.091.216l-7.203-8.466v-1.3zl7.78 9.144 6.568-14.662a1.872 1.872 0 0 0-1.962-2.691L4.248 10.619l7.959 3.95 12.225-5.726a.62.62 0 0 1 .83.3.624.624 0 0 1-.3.83z",
      clipRule: "evenodd"
    }
  )
);
var SvgSendOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SendOutlined_default = SvgSendOutlined;

export { SendOutlined_default as default };
